import api from './api';

export const quizAPI = {
  /**
   * Créer un nouveau quiz
   * @param {Object} quizData - Les données du quiz
   * @returns {Promise}
   */
  create: async (quizData) => {
    const response = await api.post('/quiz', quizData);
    return response.data;
  },

  /**
   * Récupérer tous les quiz
   * @param {Object} params - Paramètres de filtrage et pagination
   * @returns {Promise}
   */
  getAll: async (params = {}) => {
    const response = await api.get('/quiz', { params });
    return response.data;
  },

  /**
   * Récupérer un quiz par son ID
   * @param {String} id - L'ID du quiz
   * @returns {Promise}
   */
  getById: async (id) => {
    const response = await api.get(`/quiz/${id}`);
    return response.data;
  },

  /**
   * Mettre à jour un quiz
   * @param {String} id - L'ID du quiz
   * @param {Object} quizData - Les nouvelles données du quiz
   * @returns {Promise}
   */
  update: async (id, quizData) => {
    const response = await api.put(`/quiz/${id}`, quizData);
    return response.data;
  },

  /**
   * Supprimer un quiz
   * @param {String} id - L'ID du quiz
   * @returns {Promise}
   */
  delete: async (id) => {
    const response = await api.delete(`/quiz/${id}`);
    return response.data;
  },

  /**
   * Publier/dépublier un quiz (toggle)
   * @param {String} id - L'ID du quiz
   * @returns {Promise}
   */
  togglePublish: async (id) => {
    const response = await api.patch(`/quiz/${id}/publish`);
    return response.data;
  },

  /**
   * Archiver un quiz
   * @param {String} id - L'ID du quiz
   * @returns {Promise}
   */
  archive: async (id) => {
    const response = await api.patch(`/quiz/${id}/archive`);
    return response.data;
  },

  /**
   * Partager un quiz
   * @param {String} id - L'ID du quiz
   * @returns {Promise}
   */
  share: async (id) => {
    const response = await api.post(`/quiz/${id}/share`);
    return response.data;
  },

  /**
   * Commencer une tentative de quiz
   * @param {String} id - L'ID du quiz
   * @returns {Promise}
   */
  startAttempt: async (id) => {
    const response = await api.post(`/quiz/${id}/attempt`);
    return response.data;
  }
};

export default quizAPI;

